import React, { useState } from 'react'
import { NavigationHeader } from '@/components/NavigationHeader/NavigationHeader'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { AccountGroupDto } from 'api/Trading-Accounts/Types/AccountGroupDto'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'
import { useTabNavigate } from 'hooks/useTabNavigate'

interface Props {
  data?: AccountGroupDto
  isEdit: boolean
  tab: AccountGroupTab
}

export enum AccountGroupTab {
  DETAILS = 'details',
}
export const AccountGroupNavigation: React.FC<Props> = (props) => {
  const tabNavigate = useTabNavigate()

  const { data, isEdit } = props
  const [confirmationModal, setConfirmationModal] = useState<boolean>(props.isEdit)
  const [keyToChange, setKeyToChange] = useState<string>(AccountGroupTab.DETAILS)

  const handleTabClick = async (key: string) => {
    setKeyToChange(key)
    if (isEdit) setConfirmationModal(true)
    else tabNavigate(key)
  }

  const handleTabChange = (reason: boolean) => {
    if (reason) tabNavigate(keyToChange)
    setConfirmationModal(false)
  }
  return (
    <div>
      <ConfirmationModal
        contentText='The page is asking you to confirm that you want to leave - data you have enter may not be saved.'
        yesButtonText='Leave Page'
        cancelButtonText='Stay on page'
        onYes={() => handleTabChange(true)}
        onCancel={() => handleTabChange(false)}
        visible={confirmationModal}
      />
      <NavigationHeader>{data && <span>{data.name}</span>}</NavigationHeader>
      <Tabs value={props.tab} onValueChange={handleTabClick} className='mt-2'>
        <TabsList>
          <TabsTrigger value={AccountGroupTab.DETAILS}>Details</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
